import { render } from "./Chart.vue?vue&type=template&id=2e8f19f9&scoped=true&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import "./Chart.vue?vue&type=style&index=0&id=2e8f19f9&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8f19f9"]])

export default __exports__